<template>
  <div class="mainContent">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data: function () {
    return {};
  },
  created: function () {},
  methods: {},
  mounted() {
    // var map = new BMap.Map("container");
    // var point = new BMap.Point(116.404, 39.915);
  },
};
</script>
<style lang="less">
  .mainContent{
    background: #EBEBEB;
  }
</style>
<style>
  /* #newBridge{
    display: none !important;
  } */
</style>